import { permissionNames } from "../../consts/constants";

export const columns=[
    {
        label:"FirstName*",
        name:"first_name",
        component:"TextField",
        type:"text",
        required:true,
        isTextTransform:true
    },
    {
        label:"LastName*",
        name:"last_name",
        component:"TextField",
        type:"text",
        required:true,
        isTextTransform:true
    },
    {
        label:"Email*",
        name:"email",
        component:"TextField",
        type:"email",
        required:true
    },
    {
        label:"Password*",
        name:"password",
        component:"TextField",
        type:"password",
        required:true
    },
    {
        label:"Phone*",
        name:"phone_number",
        component:"TextField",
        type:"number",
        required:true
    },
]

  export const formFields = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    phone_number: "",
    [permissionNames.account]: false,
    [permissionNames.masterOfOralImplantologyProgram]: false,
    [permissionNames.externship]: false,
    [permissionNames.observationTrack]: false,
    [permissionNames.dentalAssistantObservationTrack]: false,
    [permissionNames.cadaverProgram]: false,
    [permissionNames.onlineProgram]: false,
    [permissionNames.onlineProgramTestAttempts]: false,
    [permissionNames.purchaseOnlinePrograms]: false,
    [permissionNames.subscriptions]: false,
    [permissionNames.speakers]: false,
    [permissionNames.saasAdmin]: false,
    [permissionNames.user]: false,
    [permissionNames.deleteAccount]: false,
    [permissionNames.deleteCourse]: false,
    [permissionNames.deleteSaaS]: false,
    [permissionNames.deleteCategories]: false,
    [permissionNames.deleteUser]: false,
  };
export const inputs = ["name", "lastName", "email", "password", "phone"];
